import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { store } from './app/store';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import AdministradorComponent from './components/administration/AdministradorComponent';
import esriConfig from "@arcgis/core/config.js";

// Configurar proxy para servicios de ArcGIS en desarrollo
if (window.location.origin.startsWith("http://localhost:3000")) {
    console.log("[esriConfig] Configurando interceptor para proxy de ArcGIS");
    
    // Interceptor para redirigir peticiones a idearagon.aragon.es a través del proxy
    esriConfig.request.interceptors.push({
        urls: "https://idearagon.aragon.es",
        before: function(params) {
            // Reemplazar la URL para usar el proxy local
            if (params.url && params.url.includes("https://idearagon.aragon.es")) {
                const originalUrl = params.url;
                params.url = params.url.replace("https://idearagon.aragon.es", "/arcgis-proxy");
                console.log(`[esriConfig interceptor] Convirtiendo URL: ${originalUrl} -> ${params.url}`);
            }
            return params;
        }
    });
}

let renderRouter = () => {
  if (window.location.origin.startsWith("http://localhost:3000")) {
    return <Router>
      <Routes>
        <Route path="/" element={<App></App>} />
        <Route path="/administration" element={<AdministradorComponent />}>
        </Route>
      </Routes>
    </Router>
  }
  else {
    return <Router>
    <Routes>
      <Route path="/vica/" element={<App></App>} />
      <Route path="/vica/administration" element={<AdministradorComponent />}>
      </Route>
    </Routes>
  </Router>
  }

}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>

    <Provider store={store}>
      {/*
        <Router>
        <Routes>
                  <Route path="/" element={<App></App>} />
                  <Route path="/administration" element={<AdministradorComponent />}>
          </Route>
        </Routes>
      </Router>
      */}
      {renderRouter()}
    </Provider>

  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
